// removed by extract-text-webpack-plugin
module.exports = {"event-container":"edit-event-container__event-container__264rv","flier-container":"edit-event-container__flier-container__2rUZq","preview-icon":"edit-event-container__preview-icon__3yhcD","flyer-inner":"edit-event-container__flyer-inner__1aggf","header":"edit-event-container__header__98luv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/event/EditEvent/edit-event-container.scss
// module id = 1815
// module chunks = 1